import React from 'react'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useHistory } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { IconAdd } from '../../../../../../shared/icon/icon'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleSubmitCreate } from '../../../../../../shared/form-simple/form-submit'
import { FormSimpleHiddenNumber } from '../../../../../../shared/form-simple/form-hidden-number'

export const NodeCategoryAdd = ({ parentURL, parentID, useApiForm, dataContext }) => {
  const history = useHistory()

  const apiForm = useApiForm()

  const handleSubmit = async data => {
    if (!data.parentID) {
      data.parentID = null
    }

    await apiForm.post(data)
    await dataContext.reload()
    history.replace(`${parentURL}`)
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAdd} text="Add category">
        <CardFullHeightScrollY title="Add category">
          <FormSimple onSubmit={handleSubmit}>
            <FormSimpleHiddenNumber name="parentID" value={parentID} />
            <FormSimpleText name="name" required autoFocus />
            <FormSimpleSubmitCreate backURL={parentURL} />
          </FormSimple>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
